var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBackIcon = function SvgBackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.152 3.807a.87.87 0 0 0 .077-1.128c-.256-.335-.705-.374-1.003-.086l-4.978 4.8A.845.845 0 0 0 0 8c0 .234.09.455.248.607l4.978 4.8c.298.288.747.25 1.003-.086a.87.87 0 0 0-.077-1.128L2.633 8.8h12.643c.4 0 .724-.358.724-.8 0-.442-.324-.8-.724-.8H2.633l3.519-3.393Z",
    fill: "currentColor"
  })));
};

export default SvgBackIcon;